export default __webpack_public_path__ + "static/media/software posters.8d284408.webp";